import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Icon = _resolveComponent("Icon")
  const _component_PulseInput = _resolveComponent("PulseInput")

  return (_openBlock(), _createBlock(_component_PulseInput, {
    ref: "input",
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.value) = $event)),
    valid: $data.valid,
    "onUpdate:valid": _cache[2] || (_cache[2] = $event => (($data.valid) = $event)),
    readonly: $props.loading,
    regexp: $props.regexp,
    placeholder: $props.placeholder,
    class: "search"
  }, {
    icon: _withCtx(() => [
      ($props.loading && _ctx.value)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            tiny: "",
            style: {"position":"static"},
            inline: "",
            mini: ""
          }))
        : (_ctx.value)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 1,
              class: "pointer icon",
              icon: "x-close",
              size: "1.6rem",
              stroke: "var(--brand-700)",
              "stroke-width": "1",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.value = ''))
            }))
          : (_openBlock(), _createBlock(_component_Icon, {
              key: 2,
              class: "icon pointer",
              icon: "search-md",
              size: "1.6rem",
              stroke: "var(--brand-700)",
              "stroke-width": "1"
            }))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "valid", "readonly", "regexp", "placeholder"]))
}